<template lang="html">
    <div
        :style="styleChip"
        :class="[
      `vs-chip-${color}`,
      {
        'closable': closable,
        'con-color': color,
        'bg-chip-transparent': transparent
      }
    ]"
        class="con-vs-chip">

    <span class="text-chip vs-chip--text">
      <slot/>
    </span>

        <button
            v-if="closable"
            class="btn-close vs-chip--close"
            type="button"
            @click="closeChip">
            <vs-icon
                :icon-pack="iconPack"
                :icon="closeIcon"
            />
        </button>
    </div>
</template>

<script>
import _color from '../../utils/color.js';
import Color from 'color';

export default {
    name:'MsChip',
    props:{
        item:{
            type:Boolean,
        },
        value:{},
        active:{
            type:Boolean,
            default:true,
        },
        text:{
            type:String,
            default:null,
        },
        closable:{
            type:[Boolean,String],
            default:false,
        },
        color:{
            type:String,
            default:null,
        },
        icon:{
            type:String,
            default:null,
        },
        iconPack:{
            type:String,
            default:'material-icons'
        },
        closeIcon:{
            type:String,
            default:'clear',
        },
        transparent: {
            type: Boolean,
            default: false
        }
    },
    computed:{
        styleChip () {
            let isLight = this.lightOrDark(this.color || '#FFFFFF')
            let textColour = isLight ? '#47546D' : '#FFFFFF';

            if (this.transparent) {
                textColour = _color.getColor(this.color, 1)

                if (isLight && this.veryLight(this.color)) {
                    const colorLight = Color(this.color);
                    textColour = colorLight.darken(0.3).hex()
                }
            }


            const background = this.transparent ? _color.getColor(this.color, .15) : _color.getColor(this.color, 1)
            //const color = this.transparent ? _color.getColor(this.color, 1) : this.color ? 'rgba(255,255,255,.9)' : 'rgba(0,0,0,.7)'
            const color = this.transparent ? textColour : this.color ? textColour : 'rgba(0,0,0,.7)'
            const border = this.transparent ? `1px solid ${_color.getColor(this.color, 1)}` : 'none'

            return {
                background: background,
                color: color,
                border: border,
            }
        },
        eliminado() {
            if(this.item) {
                return true
            } else {
                if(this.vsClosable) {
                    return this.value
                } else {
                    return true
                }
            }
        }
    },
    methods:{
        closeChip () {
            this.$emit('input', false)
            this.$emit('click')
        },
        remove(){
            this.$emit('vs-remove', false)
            this.$emit('input', false)
        }
    }
}
</script>